import { Component, OnInit, Input } from '@angular/core';
import { Globals } from '../../globals';
import {commonService} from "../../service/common.service";
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute,Params } from '@angular/router';
import {Observable } from 'rxjs';

@Component({
  selector: 'app-mypackages',
  templateUrl: './mypackages.component.html',
  styleUrls: ['./mypackages.component.css']
})
export class MypackagesComponent implements OnInit {
  userData:any={};
  postId:any;
  //myPackageData:any={};
  constructor(private commonService:commonService,private global: Globals,private router: Router,private route: ActivatedRoute) { }

  ngOnInit() {
    
    this.route.params.subscribe((params: Params) => {
      if(params['id']){      
        this.postId = parseInt(params['id']);
        if(isNaN(this.postId)){
          this.postId=0;
        } 

      
      }
    });

    this.commonService.profile.subscribe((data:any)=>{
      if(data && Object.keys(data).length != 0){
      this.userData=data; 
      //this.myPackageData.userId = this.userData.id;
      }else{
       this.userData={};
      }
    });
    this.userData.myPackageType = 'mypackage';
    
  }


}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/mypackages/mypackages.component.ts